import type { DomainMeta } from "@/types/maturity";

export function getMaturityColor(score: number): string {
  if (score >= 4.5) return "#047857";
  if (score >= 3.5) return "#059669";
  if (score >= 2.5) return "#1A56DB";
  if (score >= 1.5) return "#E97F0F";
  return "#DC2626";
}

export function getMaturityLabel(score: number): string {
  if (score >= 4.5) return "Optimizare";
  if (score >= 3.5) return "Gestionare";
  if (score >= 2.5) return "Definit";
  if (score >= 1.5) return "Repetabil";
  return "Inițial";
}

export function getScoreCardBackground(score: number): string {
  if (score <= 1.0) return "#FFE0E6";
  if (score < 2.5) return "#FFF0DB";
  if (score < 3.5) return "#DBEAFE";
  return "#D1FAE5";
}

export function getLevelButtonColor(level: number): {
  color: string;
  bg: string;
} {
  switch (level) {
    case 1:
      return { color: "#DC2626", bg: "#FEF2F2" };
    case 2:
      return { color: "#E97F0F", bg: "#FFF7ED" };
    case 3:
      return { color: "#1A56DB", bg: "#EFF6FF" };
    case 4:
      return { color: "#059669", bg: "#ECFDF5" };
    case 5:
      return { color: "#047857", bg: "#D1FAE5" };
    default:
      return { color: "#6B7280", bg: "#F9FAFB" };
  }
}

export const DOMAINS_META: DomainMeta[] = [
  {
    id: "GV",
    name: "GUVERNARE",
    color: "#1A56DB",
    pill: "#60A5FA",
    bg: "#EBF0FF",
    border: "#B4C6FC",
  },
  {
    id: "ID",
    name: "IDENTIFICARE",
    color: "#1976D2",
    pill: "#64B5F6",
    bg: "#E3F2FD",
    border: "#90CAF9",
  },
  {
    id: "PR",
    name: "PROTECȚIE",
    color: "#7B1FA2",
    pill: "#BA68C8",
    bg: "#F3E5F5",
    border: "#CE93D8",
  },
  {
    id: "DE",
    name: "DETECTARE",
    color: "#E65100",
    pill: "#FFB74D",
    bg: "#FFF3E0",
    border: "#FFCC80",
  },
  {
    id: "RS",
    name: "RĂSPUNS",
    color: "#C62828",
    pill: "#EF5350",
    bg: "#FFEBEE",
    border: "#EF9A9A",
  },
  {
    id: "RC",
    name: "RECUPERARE",
    color: "#2E7D32",
    pill: "#66BB6A",
    bg: "#E8F5E9",
    border: "#A5D6A7",
  },
];

export const MATURITY_LEVEL_LABELS: Record<number, string> = {
  1: "Inițial",
  2: "Repetabil",
  3: "Definit",
  4: "Gestionare",
  5: "Optimizare",
};
